import { createFileRoute } from "@tanstack/react-router";
import { LoginLayout } from "~/routes/_login/route";
import { ForgotPasswordPage } from "~/routes/_login/forgot-password";

export const Route = createFileRoute("/__main/$locale/forgot-password")({
  component: function LocaleForgotPassword() {
    return (
      <LoginLayout>
        <ForgotPasswordPage />
      </LoginLayout>
    );
  },
});
